import TransportersService from "@/services/TransportersService";

const getDefaultState = () => {
    return {
        transporter: [],
    };
};

export default {
    state: () => getDefaultState(),
    mutations: {
        setTransporter: (state, transporter) => {
            state.transporter = transporter;
        },
        setTransportersState: state => {
            Object.assign(state, getDefaultState());
        },
    },
    getters: {
        getTransporter: state => state.transporter,
    },
    actions: {
        processTransporter: async ({ dispatch, commit }) => {
            try {
                commit("setLoading", true);
                const response = await TransportersService.get();
                commit("setTransporter", response.data.data);
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        addTransporter: async ({ dispatch, commit }, transporter) => {
            try {
                commit("setLoading", true);
                const { data } = await TransportersService.create(transporter);
                await dispatch("processTransporter");
                commit({
                    type: "alert",
                    text: "Transporter added",
                    color: "info",
                    icon: "check_circle",
                });
                return data;
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        resetTransportersState: ({ commit }) => {
            commit("setTransportersState");
        },
    },
};
